import 'twin.macro';
import React from 'react';
import { Field, Form } from 'react-final-form';
import { UserProfile } from '@teetsh/app/src/types/user';
import useUpdateUser from '@teetsh/app/src/queries/user/useUpdateUser';
import { NotationSystem } from '@teetsh/app/src/types/notationSystem';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useTranslation } from 'react-i18next';
import { NotationSystems } from './NotationSystems';
import AutoSubmitForm from 'components/AutoSave';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { CarnetIcon } from 'components/Icons/icons/CarnetIcon';

export function NotationSystemsSettings() {
  const userPref = useUser();
  const { t } = useTranslation(['userSettings', 'common']);
  const updateUser = useUpdateUser();
  const { notifyError, notifySuccess } = useNotification();

  const defaultNotationsValues = [
    {
      id: '11',
      label: t('common:notations.neShort'),
      value: -2,
    },
    {
      id: '10',
      label: t('common:notations.absentShort'),
      value: -1,
    },
    {
      id: '1',
      label: t('common:notations.naShort'),
      value: 0,
    },
    {
      id: '2',
      label: t('common:notations.paMinusShort'),
      value: 16,
    },
    {
      id: '3',
      label: t('common:notations.paShort'),
      value: 32,
    },
    {
      id: '4',
      label: t('common:notations.paPlusShort'),
      value: 48,
    },
    {
      id: '5',
      label: t('common:notations.aMinusShort'),
      value: 64,
    },
    {
      id: '6',
      label: t('common:notations.aShort'),
      value: 80,
    },
    {
      id: '7',
      label: t('common:notations.aPlusShort'),
      value: 100,
    },
  ];

  return (
    <TwoColumnsCardSidebar.Container>
      <TwoColumnsCardSidebar.Section
        title={
          <div tw="flex items-center gap-2">
            <CarnetIcon tw="shrink-0 h-6 w-6" />
            {t('userSettings:notationSystems.title')}
          </div>
        }
      >
        <Form<UserProfile>
          initialValues={userPref}
          onSubmit={v =>
            updateUser(v)
              .then(() =>
                notifySuccess({
                  title: t('userSettings:notifications.modificationsSaved'),
                }),
              )
              .catch(() => {
                notifyError({ title: t('common:messages.genericError') });
              })
          }
        >
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <AutoSubmitForm />
              <p tw="mb-6">{t('userSettings:notationSystems.description')}</p>

              <Field<NotationSystem[]>
                name="notationSystems"
                format={value =>
                  Object.values(value).filter(
                    n => n.id !== '%' && n.id !== '10' && n.id !== '20',
                  )
                }
                // parse={value => deserializeNotationSystem(value)}
                render={({ input: { value, onChange } }) => (
                  <NotationSystems
                    value={value}
                    onChange={onChange}
                    defaultNotationsValues={defaultNotationsValues}
                  />
                )}
              />
            </form>
          )}
        </Form>
      </TwoColumnsCardSidebar.Section>
    </TwoColumnsCardSidebar.Container>
  );
}
